<template>
  <div class="new_year_page_area">
        <div class="new_year_page_area__bg_img">
            <img src="@/assets/new_year/background.png">
            <div class="new_year_page_area__inner">
                <div class="new_year_page_area__inner_area">
                    <div class="logo">
                        <img src="@/assets/new_year/logo.png">
                    </div>
                    <ul class="border_list">
                        <li class="border_list__item lt">
                            <img src="@/assets/new_year/border.png">
                        </li>
                        <li class="border_list__item rt">
                            <img src="@/assets/new_year/border.png">
                        </li>
                        <li class="border_list__item rb">
                            <img src="@/assets/new_year/border.png">
                        </li>
                        <li class="border_list__item lb">
                            <img src="@/assets/new_year/border.png">
                        </li>
                    </ul>
                    <div class="color_list_area">
                        <div class="color_list_area__img color_list_area__img--top">
                            <img src="@/assets/new_year/color_list.png">
                        </div>
                        <div class="color_list_area__img color_list_area__img--bottom">
                            <img src="@/assets/new_year/color_list.png">
                        </div>
                    </div>
                    <div class="first_page" v-show="page==1">
                    
                        <div class="pattern_area">
                            <div class="pattern_area__item pattern_area__item--left">
                                <img src="@/assets/new_year/parttern.png">
                            </div>
                            <div class="pattern_area__item pattern_area__item--right">
                                <img src="@/assets/new_year/parttern.png">
                            </div>
                        </div>
                        <div class="first_page__ta">
                            <h1 class="first_page__ta_txt">{{year}}년</h1>
                            <h1 class="first_page__ta_txt">송구영신</h1>
                            <h1 class="first_page__ta_tit">축복의 말씀</h1>
                            <p class="first_page__ta_sub">올해의 축복이 될 말씀을 뽑아 보세요!</p>
                        </div>
                        <img src="@/assets/new_year/cloud.png" class="first_page__cloud first_page__cloud-left">
                        <img src="@/assets/new_year/cloud.png" class="first_page__cloud first_page__cloud-right">
                        <div class="first_page__btn" v-on:click="choiceVerse()">
                            <p class="first_page__btn_txt">말씀 뽑기</p>
                        </div>
                        <div class="first_page__bia">
                            <div class="first_page__bia_extra"></div>
                            <img src="@/assets/new_year/bottom_img1.png">
                        </div>
                    </div>
                    <div class="second_page" v-show="page==2">
                        <div class="pattern_area">
                            <div class="pattern_area__item pattern_area__item--left">
                                <img src="@/assets/new_year/parttern.png">
                            </div>
                            <div class="pattern_area__item pattern_area__item--right">
                                <img src="@/assets/new_year/parttern.png">
                            </div>
                        </div>
                        <div class="second_page__angle">
                            <div class="second_page__angle-center">
                                <img src="@/assets/new_year/angle.png">
                                <div class="second_page__angle_txt_area">
                                    <div class="second_page__angle_txt_area_loading">
                                        <img src="@/assets/new_year/loading.png">
                                    </div>
                                    <p class="second_page__angle_txt">성구를 뽑는 중입니다</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="third_page" v-show="page==3">
                        <div class="transform_area" :class="scroll?'on':''">
                            <div class="capture_area" ref="capture_area">
                                <div class="pattern_area">
                                    <div class="pattern_area__item pattern_area__item--left">
                                        <img src="@/assets/new_year/parttern.png">
                                    </div>
                                    <div class="pattern_area__item pattern_area__item--right">
                                        <img src="@/assets/new_year/parttern.png">
                                    </div>
                                </div>
                                <div class="third_page__angle">
                                    <div class="third_page__angle-center">
                                        <img src="@/assets/new_year/angle.png">
                                        <div class="third_page__angle_txt_area">
                                            <h2 class="third_page__angle_tit">{{year}}</h2>
                                            <h2 class="third_page__angle_tit">축복의 말씀</h2>
                                            <div class="third_page__angle_verse">
                                                <p class="third_page__angle_txt" >{{print_verse.verse}}</p>
                                            </div>
                                            <p class="third_page__angle_book">{{print_verse.chapter}}</p>
                                        </div>
                                    </div>
                                </div>
                                <img src="@/assets/new_year/cloud.png" class="third_page__cloud third_page__cloud-left">
                                <img src="@/assets/new_year/cloud.png" class="third_page__cloud third_page__cloud-right">
                                <div class="third_page__bia" v-on:click="scrollClick()">
                                    <div class="third_page__bia_btn">
                                        <p class="third_page__bia_txt">아래로 내려보세요</p>
                                        <img class="third_page__bia_img" src="@/assets/new_year/bot_arrow.png">
                                    </div>
                                    <div class="third_page__bia_extra"></div>
                                    <img src="@/assets/new_year/bottom_img2.png">
                                </div>
                            </div>
                            <div class="finally_area">
                                <div class="pattern_area">
                                    <div class="pattern_area__item pattern_area__item--left">
                                        <img src="@/assets/new_year/parttern.png">
                                    </div>
                                    <div class="pattern_area__item pattern_area__item--right">
                                        <img src="@/assets/new_year/parttern.png">
                                    </div>
                                </div>
                                <ul class="finally_area__list">
                                    <li class="finally_area__item" v-on:click="choiceVerse()">
                                        <p class="finally_area__item_txt">말씀 다시뽑기</p>
                                    </li>
                                    <li class="finally_area__item" v-on:click="shareClick()">
                                        <p class="finally_area__item_txt">공유하기</p>
                                    </li>
                                    <li class="finally_area__item" v-on:click="imgSave()">
                                        <p class="finally_area__item_txt">이미지 저장하기</p>
                                    </li>
                                    <li class="finally_area__item" v-on:click="gotoAnother()">
                                        <p class="finally_area__item_txt">다른 테스트도 해보기</p>
                                    </li>
                                    <li class="finally_area__item" v-on:click="gotoWs()">
                                        <p class="finally_area__item_txt">말씀광장 가보기</p>
                                    </li>
                                    <li class="finally_area__item" v-on:click="scrollClick()">
                                        <p class="finally_area__item_txt">돌아가기</p>
                                    </li>
                                </ul>
                                <div class="finally_area__bia">
                                    <div class="finally_area__bia_extra"></div>
                                    <img src="@/assets/new_year/bottom_img2.png">
                                </div>
                            </div>
                        </div>
                        <div class="pyro" v-show="hide">
                            <div class="before"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
    props : ['verse','scroll', 'page','print_verse'
            ,'goto_choice','scroll_click','share_fun','goto_another','goto_ws','image_save'],
    methods: {
        choiceVerse(){
            this.goto_choice();
            setTimeout(() => {
                this.hide=true;
            }, 5000);
            setTimeout(() => {
                this.hide=false;
            }, 10000);
        },
        scrollClick(){
            this.scroll_click();
        },
        shareClick(){
            this.share_fun();
        },
        gotoAnother(){
            this.goto_another();
        },
        gotoWs(){
            this.goto_ws();
        },
        imgSave(){
            this.image_save();
        },
      
    },
    data() {
        return {
            year : new Date().getFullYear(),
            hide : true,
           
        }
    },
    mounted() {
        let month = new Date().getMonth()+1;
        let date = new Date().getDate();
        let mon_date = `${month}.${date}`;
        let year = new Date().getFullYear();
        if(mon_date=='12.28' || mon_date=='12.29' || mon_date=='12.30' || mon_date=='12.31'){
            this.year=year+1;
        }
    },
}
</script>
<style lang="scss" scoped>
  @import '@/assets/style/scss/newyear.scss';
</style>
